import { Link, useSearchParams } from 'react-router';
import { CHARACTER_REGION_LABELS, pageTitle } from '@thottbot/shared';
import { useCharacterRealms, useCharacters } from '../api/client';
import { Pager } from '../components/Pager';

/** Public imported characters, filterable by realm. */
export function Characters() {
  const [params, setParams] = useSearchParams();
  const page = Number(params.get('page') ?? '1') || 1;
  const result = useCharacters(params);
  const realms = useCharacterRealms();
  const set = (key: string, value: string) => {
    const next = new URLSearchParams(params);
    if (value) next.set(key, value);
    else next.delete(key);
    if (key !== 'page') next.delete('page');
    setParams(next);
  };
  const realmValue = params.get('region') && params.get('realm') ? `${params.get('region')}/${params.get('realm')}` : '';
  return (
    <div className="page">
      <title>{pageTitle('Characters')}</title>
      <h1>Characters</h1>
      <p className="muted">
        Characters players imported from Battle.net and chose to show. <Link to="/me">Import yours.</Link>
      </p>
      <div className="filters">
        <label>
          Realm{' '}
          <select
            value={realmValue}
            onChange={(e) => {
              const [region, realm] = e.target.value.split('/');
              const next = new URLSearchParams(params);
              if (region && realm) {
                next.set('region', region);
                next.set('realm', realm);
              } else {
                next.delete('region');
                next.delete('realm');
              }
              next.delete('page');
              setParams(next);
            }}
          >
            <option value="">All realms</option>
            {realms.data?.map((r) => (
              <option key={`${r.region}/${r.realmSlug}`} value={`${r.region}/${r.realmSlug}`}>
                {r.realmName} ({CHARACTER_REGION_LABELS[r.region]}) - {r.count}
              </option>
            ))}
          </select>
        </label>
      </div>
      {result.isPending && <p className="muted">Loading...</p>}
      {result.isError && <p className="error">Could not load characters.</p>}
      {result.data && result.data.items.length === 0 && <p className="muted">No public characters yet.</p>}
      {result.data && result.data.items.length > 0 && (
        <>
          <div className="table-scroll">
            <table className="grid" data-testid="characters">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Level</th>
                  <th>Class</th>
                  <th>Race</th>
                  <th>Realm</th>
                </tr>
              </thead>
              <tbody>
                {result.data.items.map((c) => (
                  <tr key={c.id} data-testid="character-row">
                    <td>
                      <Link to={c.url}>{c.name}</Link>
                    </td>
                    <td>{c.level}</td>
                    <td>{c.class}</td>
                    <td>{c.race}</td>
                    <td>
                      {c.realmName} ({CHARACTER_REGION_LABELS[c.region]})
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pager page={page} pageSize={result.data.pageSize} total={result.data.total} onPage={(p) => set('page', String(p))} />
        </>
      )}
    </div>
  );
}
